import { requests } from './baseServices'

export const ExpenseVatServices = {    
    //getAll: (criteria) => requests.get('api/vat', criteria),
    getAllWithOptions: (criteria) => requests.post('api/expensevat/filtered', criteria),
    getById: (id) => requests.get(`api/expensevat/${id}`),
    update: (id, template) => requests.put(`api/expensevat/${id}`, template),
    create: (template) => requests.post(`api/expensevat`, template),
    duplicate: (id) => requests.post(`api/expensevat/duplicate/${id}`),
    delete: (id) => requests.delete(`api/expensevat/${id}`),
};